import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import { ApolloConsumer } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';
import { withAppStorage } from '../utils/appStorage';
import { licensePlateIcon } from '../media/icons';
import { LargeLoadingButton } from './Buttons';
import { regNumber as regNumberValidator } from '../utils/validators';

// Same query as in CarInformations.js for cache.
const GET_CAR_INFORMATION = gql`
  query getCarInformation($regNumber: String!) {
    information: getCarInformation(regNumber: $regNumber) {
      model
      modelYear
      fuel
      engine
      wheelSize
      transmissionType
      chassisNumber
      carData: BilkodData {
        variantId: Bilkod
        brandId: BilNr
        modelId: ModellNr
      }
    }
  }
`;

const Wrapper = styled.div`
  display: block;
`;

const Form = styled.form`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const SearchInput = styled.input`
  background-image: url(${licensePlateIcon});
  background-size: 30px 57px;
  background-repeat: no-repeat;
  background-position: 15px 4px;
  color: ${p => p.theme.colors.inputText};
  border: none;
  font-size: 1.5625rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  line-height: 1.2;
  max-width: 275px;
  padding: 0 20px 0 60px;
  width: 100%;

  ${breakpoints.medium`
    font-size: 1.875rem;
  `};

  ${breakpoints.large`
    font-size: 2.1875rem;
    margin-right: 13px;
  `};

  ::-webkit-input-placeholder {
    color: ${p => p.theme.colors.inputText};
  }
`;

const ValidationMessage = styled.div`
  color: ${p => p.theme.colors.error};
  margin-bottom: 20px;
  text-align: center;
`;

class LargeNumberSearch extends Component {
  state = {
    regNumber: '',
    validation: '',
    loading: false
  };

  componentDidMount = () => {
    const regNumber = this.props.appStorageData.regNumber;

    if (regNumber) {
      this.setState({
        regNumber: regNumber
      });
    }
  };

  handleCarNumberChange = event => {
    this.setState({
      regNumber: event.target.value.toUpperCase(),
      validation: '',
      loading: false
    });
  };

  render() {
    return (
      <ApolloConsumer>
        {client => (
          <Wrapper>
            <Form
              onSubmit={async event => {
                event.preventDefault();

                this.setState({
                  loading: true
                });

                const regNumber = this.state.regNumber
                  .toLowerCase()
                  .replace(/\s/g, ''); // emove all whitespace

                if (!regNumber || !regNumberValidator(regNumber)) {
                  this.setState({
                    validation: 'Vennligst skriv inn et registreringsnummer!',
                    loading: false
                  });

                  return null;
                }

                let data = null;

                try {
                  ({ data } = await client.query({
                    query: GET_CAR_INFORMATION,
                    variables: { regNumber: regNumber }
                  }));
                } catch (error) { }

                if (!data || !data.information) {
                  this.setState({
                    validation: 'Fant ingen bil på dette registreringsnummeret!',
                    loading: false
                  });

                  return null;
                }

                this.props.appStorage.set(
                  'regNumber',
                  this.state.regNumber.toUpperCase()
                );

                const query = qs.parse(this.props.location.search, {
                  arrayFormat: 'bracket'
                });

                return this.props.history.push({
                  pathname: '/bildeler/',
                  search: qs.stringify(
                    {
                      ...query,
                      regnr: regNumber,
                      merke: data.information.carData.brandId,
                      modell: data.information.carData.modelId,
                      variant: data.information.carData.variantId
                    },
                    { arrayFormat: 'bracket' }
                  )
                });
              }}
            >
              <SearchInput
                placeholder="AB 12345"
                value={this.state.regNumber}
                onChange={this.handleCarNumberChange}
              />

              <LargeLoadingButton loading={this.state.loading}>
                Søk
              </LargeLoadingButton>
            </Form>

            {this.state.validation && (
              <ValidationMessage>{this.state.validation}</ValidationMessage>
            )}
          </Wrapper>
        )}
      </ApolloConsumer>
    );
  }
}

export default withRouter(withAppStorage(LargeNumberSearch));
